import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { ColorPicker, useColor, toColor } from "react-color-palette";

import MoonIcon from "./icons/MoonIcon";
import SunIcon from "./icons/SunIcon";

import { themes } from "../../../../theme-colors";

import {
  Switch,
  Option,
  ColorPickerWrapper,
  ColorsContainer,
  ColorBox,
} from "./styled";

import getReadableColor from "./getReadableColor";

import "react-color-palette/lib/css/styles.css";

const DualColorPicker = ({
  value,
  setValue,
  width,
  height,
  hideColorTiles,
  hasThemeSelector = true,
  defaultTheme = "light",
}) => {
  const [theme, setTheme] = useState(defaultTheme);
  const [colorType, setColorType] = useState("accent");

  const currentColor = value[colorType][theme];

  const [color, setColor] = useColor("hex", currentColor || "#df1111");

  const containerRef = useRef();

  useEffect(() => {
    if (currentColor !== color.hex) {
      const timer = setTimeout(() => {
        setValue({
          ...value,
          [colorType]: { ...value[colorType], [theme]: color.hex },
        });
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [color]);

  useEffect(() => {
    setColor(toColor("hex", currentColor || "#df1111"));
  }, [value, colorType, theme]);

  useEffect(() => {
    const elements = document.getElementsByClassName("rcp-fields-element");

    if (elements) {
      Array.from(elements).forEach((el, index) => {
        const [label] = el.getElementsByClassName("rcp-fields-element-label");

        label.innerText = index ? "Hex" : "Rgb";
      });
    }
  }, [containerRef?.current]);

  return (
    <ColorPickerWrapper ref={containerRef}>
      {hasThemeSelector && (
        <Switch>
          <Option
            active={theme === "light"}
            onClick={() => {
              setTheme("light");
              window.AP.events.emit("theme-changed", themes.light);
            }}
          >
            <SunIcon />
          </Option>
          <Option
            active={theme === "dark"}
            onClick={() => {
              setTheme("dark");
              window.AP.events.emit("theme-changed", themes.dark);
            }}
          >
            <MoonIcon />
          </Option>
        </Switch>
      )}

      <ColorPicker
        width={width}
        height={height}
        color={color}
        onChange={setColor}
        onChangeComplete={({ hex }) => {
          if (currentColor !== hex) {
            if (colorType === "accent") {
              const text = getReadableColor(hex);

              setValue({
                accent: { ...value.accent, [theme]: hex },
                text: { ...value.text, [theme]: text },
              });
            } else {
              setValue({
                ...value,
                text: { ...value.text, [theme]: hex },
              });
            }
          }
        }}
        hideHSV
        alpha
      />

      {!hideColorTiles && (
        <ColorsContainer>
          <span>
            <ColorBox
              color={value.accent[theme]}
              onClick={() => setColorType("accent")}
              isSelected={colorType === "accent"}
            />
            Accent
          </span>
          <span>
            <ColorBox
              color={value.text[theme]}
              onClick={() => setColorType("text")}
              isSelected={colorType === "text"}
            />
            Text
          </span>
        </ColorsContainer>
      )}
    </ColorPickerWrapper>
  );
};

DualColorPicker.propTypes = {
  //value: PropTypes.string.isRequired,
  hideColorTiles: PropTypes.bool,
  setValue: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

DualColorPicker.defaultProps = {
  hideColorTiles: false,
};

export default DualColorPicker;
